import { AbstractEvent } from '@/models/abstractEvent';
import { ILiveDataAPI } from '@/types/event/live';

export class LiveItem extends AbstractEvent {
    public attacksAway: number | null;
    public attacksHome: number | null;
    public cornersAway: number | null;
    public cornersHome: number | null;
    public dangerousAttacksAway: number | null;
    public dangerousAttacksHome: number | null;
    public foulsAway: number | null;
    public foulsHome: number | null;
    public hitWoodworkAway: number | null;
    public hitWoodworkHome: number | null;
    public lastAwayGoalAt: string | null;
    public lastHomeGoalAt: string | null;
    public possessionTimeAway: number | null;
    public possessionTimeHome: number | null;
    public redAway: number | null;
    public redHome: number | null;
    public score: string | null;
    public shotsAway: number | null;
    public shotsHome: number | null;
    public shotsOnTargetAway: number | null;
    public shotsOnTargetHome: number | null;
    public time: string | null;
    public timeH: number | null;
    public timeMin: number | null;
    public yellowAway: number | null;
    public yellowHome: number | null;

    constructor(data: ILiveDataAPI) {
        super(data);

        this.time = data.time;
        this.timeH = data.time_h;
        this.timeMin = data.time_min;
        this.score = data.score;
        this.lastHomeGoalAt = data.last_home_goal_at;
        this.lastAwayGoalAt = data.last_away_goal_at;
        this.redHome = data.red_home;
        this.redAway = data.red_away;
        this.yellowHome = data.yellow_home;
        this.yellowAway = data.yellow_away;
        this.attacksHome = data.attacks_home;
        this.attacksAway = data.attacks_away;
        this.dangerousAttacksHome = data.dangerous_attacks_home;
        this.dangerousAttacksAway = data.dangerous_attacks_away;
        this.shotsHome = data.shots_home;
        this.shotsAway = data.shots_away;
        this.shotsOnTargetHome = data.shots_on_target_home;
        this.shotsOnTargetAway = data.shots_on_target_away;
        this.cornersHome = data.corners_home;
        this.cornersAway = data.corners_away;
        this.possessionTimeHome = data.possession_time_home;
        this.possessionTimeAway = data.possession_time_away;
        this.foulsHome = data.fouls_home;
        this.foulsAway = data.fouls_away;
        this.hitWoodworkHome = data.hit_woodwork_home;
        this.hitWoodworkAway = data.hit_woodwork_away;

        if (data.event_date) {
            this.eventDate = data.event_date;
        }
    }

    override get currentScore(): string {
        return this.score || this.scoreIr || this.scoreFt || '';
    }

    override get isLive(): boolean {
        return this.isLiveStarted === 1 || (this.time !== null && this.time !== '');
    }
}
